import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { deviceInformationFeatureKey, deviceInformationReducer } from './device-information.reducer';
import { EffectsModule } from '@ngrx/effects';
import { DeviceInformationEffects } from './device-information.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(deviceInformationFeatureKey, deviceInformationReducer),
    EffectsModule.forFeature([DeviceInformationEffects]),
  ],
  providers: [],
})
export class DeviceInformationStoreModule {}
